import CONFIG from '../../globalVariables';

class PageContentService {
  static async getPage(slug) {
    const url = `${CONFIG.PATH_API}/api/content/pages/${slug}`;
    try {
      const res = await fetch(url);
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        return data.data;
      }
      return null;
    } catch (_) {
      return null;
    }
  }

  static async getOverallTemplates() {
    const url = `${CONFIG.PATH_API}/api/content/templates?type=overall`;
    try {
      const res = await fetch(url);
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) return Array.isArray(data.data) ? data.data : [];
      return [];
    } catch (_) {
      return [];
    }
  }
}

export default PageContentService;
